
import { Button } from "@/components/ui/button";
import { ShoppingCart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';


const Hero = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const scrollToDemo = () => {
    const demoSection = document.getElementById('demo');
    if (demoSection) {
      demoSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section className="bg-gradient-to-br from-blue-50 via-green-50 to-yellow-50 py-20 px-4">
      <div className="container mx-auto text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold text-gray-800 mb-6 leading-tight">
            {t('home.makeGroceryShopping')}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-green-500 block">
              {t('home.funAndInteractive')}
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto">
            {t('home.transformYourGroceryTripsIntoExcitingAdventures')}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Button
              onClick={() => navigate('/login')}
              className="bg-gradient-to-r from-blue-500 to-green-500 hover:from-blue-600 hover:to-green-600 text-white px-8 py-6 text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              <ShoppingCart className="mr-2" size={20} />
              {t('home.startShoppingForFree')}
            </Button>

            <Button
              variant="outline"
              onClick={scrollToDemo}
              className="border-2 border-blue-500 text-blue-500 hover:bg-blue-50 px-8 py-6 text-lg rounded-full transition-all duration-300"
            >
              {t('home.watchDemo')}
            </Button>
          </div>

          {/* <div className="flex justify-center items-center gap-8 text-gray-500">
            <div className="flex items-center gap-2">
              <Star className="text-yellow-400 fill-current" size={20} />
              <span>4.9/5 Parent Rating</span>
            </div>
            <div className="flex items-center gap-2">
              <Heart className="text-red-400 fill-current" size={20} />
              <span>Loved by 10k+ Families</span>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default Hero;
